import { amountToString } from '@orus.eu/amount'
import type { Jsonable } from '@orus.eu/error'

import type { Quote } from '../quote.ts'

export type SerializedQuoteData = {
  yearlyRecurrenceAmount: string
  monthlyRecurrenceAmount: string
}

export function quoteV2ToSerializedQuoteData<
  Deductibles extends Jsonable,
  YearlyTaxName extends string | void,
  GuaranteeName extends string,
  RecurringOptionName extends string,
  OneTimeOptionName extends string,
  MonthlyFeesName extends string | void,
>(
  quote: Quote<Deductibles, YearlyTaxName, GuaranteeName, RecurringOptionName, OneTimeOptionName, MonthlyFeesName>,
): string {
  return `Yearly price : ${amountToString(quote.yearly.final.total.total, {
    addCurrency: true,
    displayDecimals: true,
  })} | Monthly price : ${amountToString(quote.monthly.final.total.subsequentMonthsTotal, {
    addCurrency: true,
    displayDecimals: true,
  })}`
}
